$(() => {
    initShowMore();
});

function initShowMore() {
    const $seeMore = $('.see-more');

    $seeMore.on('click', function() {
        $(this).prev().slideToggle("slow");

        $(this).find('i').toggleClass('ph-caret-down ph-caret-up');
        $(this).find($('[data-attribute="see-more"]')).toggle();
        $(this).find($('[data-attribute="see-less"]')).toggle();
    })
}